"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _startListHelp = _interopRequireDefault(require("./start-list-help"));
var _startListNotes = _interopRequireDefault(require("./start-list-notes"));
var _startListDay = _interopRequireDefault(require("./start-list-day"));
var _reset_or_fix = _interopRequireDefault(require("./reset_or_fix"));
var _publishButton = _interopRequireDefault(require("./publishButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement("p", null, "You must create your races (on the races tab) before you can set up a start list"));
var _ref2 = /*#__PURE__*/_react.default.createElement("h2", {
  className: "pull-xs-right>"
}, "Start List");
var _ref3 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_startListHelp.default, null));
var _ref4 = /*#__PURE__*/_react.default.createElement("br", null);
class StartList extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false
    });
    _defineProperty(this, "_setLoading", result => {
      this.setState({
        loading: true
      });
      result.then(() => this.setState({
        loading: false
      }), () => this.setState({
        loading: false
      }));
    });
    _defineProperty(this, "_initialiseStartList", () => {
      this._setLoading(this.props.initialiseStartList(this.props.competition.id));
    });
    _defineProperty(this, "_onUpdateCompetition", (value, field) => {
      this.props.onUpdateCompetition(this.props.competition.id, field, value);
    });
    _defineProperty(this, "_getNextDay", dayNumber => {
      // if only one day in competition no next day
      if (this.props.competition.competitionDays.length <= 1) return null;
      // return the id for the next day of the competition if there is one, otherwise go back to the first day.
      let newDayNumber = dayNumber + 1;
      if (newDayNumber > this.props.competition.competitionDays.length) newDayNumber = 1;
      return this.props.competition.competitionDays[newDayNumber - 1].id;
    });
  }
  render() {
    const competition = this.props.competition;
    if (!competition.isAdministratedByUser) return null;
    if (!competition.hasRaces) return _ref;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref2, _ref3, /*#__PURE__*/_react.default.createElement(_startListNotes.default, {
      competitionID: competition.id,
      startListNotes: competition.startListNotes
    }), /*#__PURE__*/_react.default.createElement(_publishButton.default, {
      competition: competition,
      onUpdateCompetition: this.props.onUpdateCompetition
    }), _ref4, !competition.competitionDays.some(day => day.startListRuns.length) ? /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this._initialiseStartList
    }, "Click to Generate Default Start List Parameters") : /*#__PURE__*/_react.default.createElement("div", null, competition.displayStartList ? null : /*#__PURE__*/_react.default.createElement(_reset_or_fix.default, {
      competitionID: competition.id
    }), !competition.useFreeCode ? null : /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "presortStartListByFreeCode",
      checked: competition.presortStartListByFreeCode,
      onChange: this._onUpdateCompetition,
      label: "Sort entries by code before bib number"
    }), !competition.useFreeCode || !competition.presortStartListByFreeCode ? null : /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "isNullFreeCodesFirst",
      checked: competition.isNullFreeCodesFirst,
      onChange: this._onUpdateCompetition,
      label: "Paddlers without a free code go first"
    }), competition.competitionDays.filter(d => d.startListRuns.length).map(day => /*#__PURE__*/_react.default.createElement(_startListDay.default, {
      key: day.id,
      competitionID: this.props.competition.id,
      competitionDay: day,
      nextDayID: this._getNextDay(day.dayNumber)
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = _mergeBqlQueries({
  id: true,
  displayStartList: true,
  startListNotes: true,
  isAdministratedByUser: true,
  hasRaces: true,
  useFreeCode: true,
  presortStartListByFreeCode: true,
  isNullFreeCodesFirst: true,
  competitionDays: _mergeBqlQueries({
    id: true,
    dayNumber: true,
    startListRuns: {
      id: true
    }
  }, _startListDay.default.partials.CompetitionDay)
}, _publishButton.default.partialQueries.Competition);
var _default = exports.default = (0, _reactBicycle.connect)(StartList, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref5
}), (client, props) => ({
  initialiseStartList(competitionID) {
    return client.update('StartListRun.initialiseStartList', {
      competitionID
    });
  },
  onUpdateCompetition(id, field, value) {
    return client.update('Competition.set', {
      id,
      field,
      value
    });
  }
}));